/* medical_iot.svg.js */

module.exports = {
    icon: `
        <svg width="16" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <mask id="mask0_7297_246" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="25" height="25">
            <rect class="foreground-gl" x="0.961182" y="0.5896" width="24" height="24"/>
            </mask>
            <g mask="url(#mask0_7297_246)">
            <path class="foreground-gl" d="M8.96118 21.5896V16.5896H3.96118V8.5896H8.96118V3.5896H16.9612V8.5896H21.9612V16.5896H16.9612V21.5896H8.96118ZM10.9612 19.5896H14.9612V14.5896H19.9612V10.5896H14.9612V5.5896H10.9612V10.5896H5.96118V14.5896H10.9612V19.5896Z"/>
            </g>
        </svg>

`,
};
